import React from "react"
import { useDispatch } from "react-redux"
import { hideAllForms, showAllForms } from "reduxSlices/formSubmissionTableSlice"
import MassSelection from "shared/MassSelection"
import { SidebarCollapsibleContent } from "shared/Sidebar"
import SubmissionFormList from "./SubmissionFormList"

const SubmissionFormFilter = () => {
  const dispatch = useDispatch()

  return (
    <SidebarCollapsibleContent title="Filter By Form">
      <div className="flex flex-col gap-2">
        <MassSelection
          deselectAll={() => dispatch(hideAllForms())}
          selectAll={() => dispatch(showAllForms())}
        />
        <SubmissionFormList className="mb-4" />
      </div>
    </SidebarCollapsibleContent>
  )
}

export default SubmissionFormFilter
